import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { EThemeName, ThemeService } from '@wind-log_library/fe-component-library';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent implements OnInit, OnChanges {
  public theme$: Observable<EThemeName>;
  public readonly eThemeName = EThemeName;
  public showBar = false;
  public value = null;

  @Input() compareWith = 50;
  @Input() element: any;
  @Input() rowNumber: number;
  @Input() calculate(element: any) {
  }

  constructor(private themeService: ThemeService) {
  }

  ngOnInit() {
    this.theme$ = this.themeService.getTheme();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.element && this.calculate) {
      this.value = this.calculate(this.element);
      this.showBar = true;
    }
  }
}
